import { render, staticRenderFns } from "./CollapsibleContainer.vue?vue&type=template&id=f010a688&scoped=true&"
import script from "./CollapsibleContainer.vue?vue&type=script&lang=js&"
export * from "./CollapsibleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f010a688",
  null
  
)

export default component.exports